<template>
  <v-app
    v-if="i18nLoaded"
    :class="[
      getKeyboardOpen ? classes + ' keyboard-open' : classes,
      { 'platform-ios': platformIos }
    ]"
  >
    <NewsBannerSlider v-if="isAuthenticated" />
    <NavbarSSC v-if="site == 'selfscanning'" :key="key" />
    <Navbar v-else :key="key" :applicationConfig="applicationConfig" />
    <v-navigation-drawer
      v-model="drawerLeft"
      width="290"
      touchless
      left
      app
      clipped
      class="categories"
    >
      <CategoryTreeHorizontal v-show="site == 'ecommerce'" />
      <SiteNavigationDrawer v-show="site == 'site'" />
      <NavigationDrawerSSC v-show="site == 'selfscanning'" />
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="drawerRight"
      disable-resize-watcher
      touchless
      temporary
      clipped
      right
      app
      width="600"
      id="cart-right-drawer"
      class="cart-drawer white"
    >
      <div class="cart-info" v-if="drawerRight">
        <CartInfoList :isCart="true" class="infos py-3 pb-sm-0" />
        <CartItemList
          class="items-list"
          :full="$vuetify.breakpoint.xs"
          :checkMobile="iosMobile"
          itemListName="Cart"
        />
        <CartSummary
          class="summary py-0"
          :class="{ 'cart-item-list-no-checkout-osx': iosMobile }"
        />
      </div>
    </v-navigation-drawer>

    <!-- <v-navigation-drawer
      class="links-list white"
      v-if="cordovaPlatform"
      v-model="drawerLinks"
      touchless
      right
      clipped
      app
      width="auto"
      @close="drawerLinks = false"
    >
      <MenuLinksList :links="footerLinks" @close="drawerLinks = false" />
    </v-navigation-drawer> -->
    <v-main v-if="site == 'selfscanning'" class="selfscanning-main">
      <ebsn-style
        :target="applicationConfig"
        path="category_advanced.CSS_STYLE"
      />
      <div class="content-wrap">
        <Selfscanning />
      </div>
    </v-main>
    <v-main v-else>
      <ebsn-style
        :target="applicationConfig"
        path="category_advanced.CSS_STYLE"
      />
      <div class="content-wrap">
        <v-skeleton-loader
          type="actions, image, article,image"
          v-if="loading"
          :loading="loading"
        ></v-skeleton-loader>
        <router-view v-else></router-view>
      </div>
      <category-block
        v-if="applicationConfig"
        :target="applicationConfig"
        position="tutorial"
        class="category-block category-block-tutorial"
      />
      <Footer :links="footerLinks" />
      <div class="privacy-links" v-if="isCordova">
        <PrivacyLinks></PrivacyLinks>
      </div>
    </v-main>

    <ScrollTop />
    <SsoUserCard />
    <!-- <GiftCertificateWindow /> -->
  </v-app>
</template>
<style lang="scss">
.cart-info {
  .infos {
    background-color: var(--v-grey-lighten2) !important;
    height: #{$cart-info-height};
  }
  .summary {
    background: rgb(238, 238, 238);
    background: linear-gradient(
      rgba(238, 238, 238, 0.7) 0%,
      rgba(238, 238, 238, 1) 15%,
      rgba(238, 238, 238, 1) 100%
    );
    position: fixed;
    bottom: 0;
    width: 100%;

    height: #{$summary-height};
    border-top-color: var(--v-grey-lighten2);
  }
  .items-list {
    $background: $white;
  }
  .cart-item-list {
    height: calc(100vh - 258px);
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    height: auto;
    .items-list {
      background: transparent;
    }
    .infos {
      height: auto;
      box-shadow: 0px 3px 6px #00000029 !important;
    }
    .summary {
      box-shadow: 0px -3px 6px #00000029 !important;
    }
    .cart-item-list-no-checkout-osx {
      padding-bottom: $summary-height-osx !important;
    }
  }
}
.privacy-links {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  padding: 0 16px;
  a {
    text-decoration: none;
  }
}
</style>
<script>
import CartSummary from "@/components/cart/CartSummary.vue";
import CartInfoList from "@/components/cart/CartInfoList.vue";
import CartItemList from "@/components/cart/CartItemList.vue";
import CategoryTreeHorizontal from "@/components/navigation/CategoryTree.vue";
import SiteNavigationDrawer from "@/components/navigation/SiteNavigationDrawer.vue";
import CheckDisclaimerDialog from "@/components/profile/CheckDisclaimerDialog.vue";
import NewsBannerSlider from "@/components/news/NewsBannerSlider.vue";
import SsoUserCard from "@/components/profile/SsoUserCard.vue";
// import GiftCertificateWindow from "@/components/gift/GiftCertificateWindow.vue";
// // import CategoryBlock from "@/components/categoryBlock/CategoryBlock.vue";
import PrivacyLinks from "@/components/navigation/PrivacyLinks.vue";

import login from "~/mixins/login";
import version from "~/mixins/version";

import UserService from "~/service/userService";
import CategoryService from "~/service/categoryService";

import { mapActions, mapGetters } from "vuex";
import findIndex from "lodash/findIndex";
import { setLocale } from "@/plugins/i18n";

// import FingerprintJS from "@fingerprintjs/fingerprintjs";
import ScrollTop from "./components/ScrollTop.vue";
import analyticsService from "./commons/service/analyticsService";
import NavbarSSC from "./components/selfscanning/NavbarSSC.vue";
import NavigationDrawerSSC from "./components/selfscanning/NavigationDrawerSSC.vue";
import Selfscanning from "./views/selfscanning/Selfscanning.vue";

export default {
  name: "App",
  components: {
    CategoryTreeHorizontal,
    SiteNavigationDrawer,
    CartInfoList,
    CartSummary,
    CartItemList,
    NewsBannerSlider,
    // CategoryBlock,
    Footer: () =>
      process.env.CORDOVA_PLATFORM
        ? import("@/components/navigation/BottomNavBar.vue")
        : import("@/components/navigation/Footer.vue"),
    Navbar: () =>
      process.env.CORDOVA_PLATFORM
        ? import("@/components/navigation/NavbarMobile.vue")
        : import("@/components/navigation/Navbar.vue"),
    SsoUserCard,
    ScrollTop,
    PrivacyLinks,
    NavbarSSC,
    NavigationDrawerSSC,
    Selfscanning
    // ,
    // GiftCertificateWindow
  },
  mixins: [login, version],
  data() {
    return {
      initialHref: window.location.href,
      loading: true,
      footerLinks: [],
      applicationConfig: null,
      i18nLoaded: false,
      key: 1,
      classes: process.env.CORDOVA_PLATFORM ? "is-cordova" : "",
      platformIos: false,
      keyboardOpen: false,
      iosMobile: false,
      attValue: false
    };
  },
  metaInfo: {
    title: "Demo",
    titleTemplate: "%s - Demo",
    meta: [
      { charset: "utf-8" },
      {
        vmid: "description",
        name: "description",
        content:
          "Demo Spesa Online è il nuovissimo servizio di Tigros che consente di fare acquisti su un vasto assortimento di prodotti in totale comodità da casa, con semplicità e rapidità"
      },
      {
        name: "keywords",
        content: "Demo Spesa Online supermercato"
      },
      { name: "viewport", content: "width=device-width, user-scalable=no" },
      { name: "author", content: "Digitelematica s.r.l." },
      // Open Graph Metas
      {
        property: "og:locale",
        content: "it_IT"
      },
      {
        property: "og:title",
        content: "%s - Demo"
      },
      {
        property: "og:type",
        content: "website"
      },
      {
        property: "og:url",
        content: location.href
      },
      {
        property: "og:image",
        content:
          window.location.host + global.config.socialLogo ||
          "/logo/social-logo.png"
      },
      {
        property: "og:image:alt",
        content:
          "Demo Spesa Online è il nuovissimo servizio di Demo che consente di fare acquisti su un vasto assortimento di prodotti in totale comodità da casa, con semplicità e rapidità"
      },
      {
        property: "og:site_name",
        content: "Demo"
      },
      // Twitter Metas
      {
        name: "twitter:card",
        content: "summary_large_image"
      },
      {
        name: "twitter:title",
        content: "%s - Demo"
      },
      {
        name: "twitter:image",
        content:
          window.location.host + global.config.socialLogo ||
          "/logo/social-logo.png"
      },
      {
        name: "twitter:url",
        content: location.href
      }
    ]
  },
  computed: {
    ...mapGetters({
      needRestart: "needRestart",
      isAuthenticated: "cart/isAuthenticated"
    }),
    drawerLeft: {
      get() {
        return this.$store.state.app.drawerLeft;
      },
      set(value) {
        this.$store.commit("app/updatedDrawerLeft", value);
      }
    },
    drawerRight: {
      get() {
        return this.$store.state.app.drawerRight;
      },
      set(value) {
        this.$store.commit("app/updatedDrawerRight", value);
      }
    },
    getUserId() {
      return this.$store.state.cart.cart.user
        ? this.$store.state.cart.cart.user.userId
        : undefined;
    },
    getKeyboardOpen: function() {
      return this.keyboardOpen;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  methods: {
    ...mapActions({
      updateAuth: "cart/updateAuth",
      resetFilters: "category/resetFilters",
      updateLastStartTime: "app/updateLastStartTime",
      updateFingerprint: "app/updateFingerprint"
    }),

    checkOsx() {
      var userAgent = [];
      var version = [];
      var versionNumber = 0;
      if (navigator.userAgent.indexOf("iPhone") > -1) {
        userAgent = navigator.userAgent.split(" ");
        userAgent.filter(ua => {
          if (ua.indexOf("Version/") > -1) {
            version = ua.split("/");
          }
        });
        versionNumber = parseFloat(version[1]);
        if (version[0] == "Version") {
          if (versionNumber < 15) {
            this.iosMobile = true;
          } else {
            this.iosMobile = false;
          }
        } else {
          this.iosMobile = false;
        }
      }
    },
    fetchFooterLinksMenu() {
      // CmService.getMenuByLocation("footer").then(
      //   data => (this.footerLinks = data)
      // );
      this.footerLinks = [
        {
          templateNavItemId: 84,
          templateNavItemType: {
            templateNavItemTypeId: 4,
            name: "Link"
          },
          templateNavItemNavigationType: {
            templateNavItemNavigationTypeId: 1,
            name: "link"
          },
          name: "Service",
          itemUrl: "",
          metaData: {},
          templateNavItems: [
            {
              templateNavItemId: 549,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Contact",
              itemUrl: "/page/chi-siamo",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 548,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Help",
              itemUrl: "/page/valori-e-mission",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 699,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Account",
              itemUrl: "/page/prodotti-a-marchio/",
              metaData: {},
              templateNavItems: []
            },
            {
              templateNavItemId: 16824,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "My product list",
              itemUrl: "/page/progresso-sostenibile",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 2029,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Codice etico",
              itemUrl: "/p/wp-content/uploads/2021/01/Codice-Etico.pdf",
              metaData: {},
              templateNavItems: []
            },
            {
              templateNavItemId: 3522,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "My downloads",
              itemUrl:
                "/p/wp-content/uploads/2021/01/Modello_231_aggiornato_2020.pdf",
              metaData: {},
              templateNavItems: []
            }
          ]
        },
        {
          templateNavItemId: 85,
          templateNavItemType: {
            templateNavItemTypeId: 4,
            name: "Link"
          },
          templateNavItemNavigationType: {
            templateNavItemNavigationTypeId: 1,
            name: "link"
          },
          name: "Information",
          itemUrl: "",
          metaData: {
            templatenavitemnavigationtype: {
              TEST: "test pdv"
            }
          },
          templateNavItems: [
            {
              templateNavItemId: 1,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Imprint",
              itemUrl: "/punti-vendita/Altopascio",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 2,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Terms and Conditions",
              itemUrl: "/punti-vendita/Cagliari",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 3,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Data & Privacy",
              itemUrl: "/punti-vendita/Cecina",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 4,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Newsletter",
              itemUrl: "/punti-vendita/Empoli",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            }
          ]
        },
        {
          templateNavItemId: 86,
          templateNavItemType: {
            templateNavItemTypeId: 4,
            name: "Link"
          },
          templateNavItemNavigationType: {
            templateNavItemNavigationTypeId: 1,
            name: "link"
          },
          name: "Our Brands",
          itemUrl: "",
          metaData: {
            templatenavitemnavigationtype: {
              TEST: "test servizi"
            }
          },
          templateNavItems: []
        },
        {
          templateNavItemId: 592,
          templateNavItemType: {
            templateNavItemTypeId: 4,
            name: "Link"
          },
          templateNavItemNavigationType: {
            templateNavItemNavigationTypeId: 1,
            name: "link"
          },
          name: "Categories",
          itemUrl: "",
          metaData: {},
          templateNavItems: [
            {
              templateNavItemId: 8235,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "100 years of Walterscheid",
              itemUrl: "/page/sanificazione",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 547,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Company",
              itemUrl: "/page/certificazioni",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 1396,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Products",
              itemUrl: "/richiamo-prodotti",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 2026,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Online tools",
              itemUrl: "/page/privacy-policy",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 3513,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Downloads",
              itemUrl: "/page/web-policy",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 3519,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Videos",
              itemUrl: "/page/cookie-policy",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 3833,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Service & contact",
              itemUrl: "/page/condizioni-vendita",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            },
            {
              templateNavItemId: 3838,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name: "Carrers",
              itemUrl: "/page/utilizzo-partita-iva",
              metaData: {
                templatenavitemnavigationtype: {}
              },
              templateNavItems: []
            }
          ]
        },
        {
          templateNavItemId: 597,
          templateNavItemType: {
            templateNavItemTypeId: 4,
            name: "Link"
          },
          templateNavItemNavigationType: {
            templateNavItemNavigationTypeId: 1,
            name: "link"
          },
          name: "Newsletter",
          itemUrl: "",
          metaData: {},
          templateNavItems: [
            {
              templateNavItemId: 1556,
              templateNavItemType: {
                templateNavItemTypeId: 4,
                name: "Link"
              },
              templateNavItemNavigationType: {
                templateNavItemNavigationTypeId: 1,
                name: "link"
              },
              name:
                "Get informed about the latest products and offers per email.",
              itemUrl: "/news",
              metaData: {},
              templateNavItems: []
            }
          ]
        }
      ];
    },
    async fetchApplicationConfig() {
      try {
        let result = await CategoryService.getCategoryBySlug("application");
        this.applicationConfig = result;
      } catch (err) {
        console.log(err);
      }
    },
    async onResume() {
      var _this = this;
      var hash;
      global.EventBus.$emit("resume");
      setTimeout(async function() {
        hash = findIndex(global.config.hashNotReload, function(o) {
          return window.location.hash.indexOf(o) !== -1;
        });
        var needRestart =
          new Date().getTime() - _this.$store.state.app.lastStartTime >
          global.config.reloadAfterMillis;
        if (hash === -1 && needRestart) {
          global.EventBus.$emit("restart");
        } else {
          if (hash === -1 && _this.$cookies.get("X-Ebsn-Session")) {
            await _this.loadCart();
          }
          global.EventBus.$emit("reload");
        }
      }, 100);
    },
    async handleLogin() {
      this.doLogin("response419");
    },
    async onDeepLinks(path, queryString) {
      var _this = this;
      var currentQuery = {};
      console.log("onDeepLinks :::: ", path);
      console.log("onDeepLinks queryString :::: ", queryString);
      console.log("_this.$router :::: ", _this.$router);
      setTimeout(async function() {
        if (queryString) {
          currentQuery.q = queryString.replace("q=", "").replace(/%20/g, " ");
          console.log("onDeepLinks currentQuery :::: ", currentQuery);
          _this.$router.push({
            path: "/search",
            name: "Search",
            query: currentQuery
          });
        } else {
          _this.$router.push(path);
        }
      }, 100);
    },
    resolveRoute(data) {
      var _this = this;
      var currentQuery = {};
      console.log("resolveRoute :::: ", data);
      if (global.config.domainWhitelist.includes(data.host)) {
        let queryString = data.queryString;
        if (
          data.path.indexOf("/ristoranti-buongusto/") > -1 &&
          data.path.indexOf("/ristoranti-buongusto/buongusto-caffe") == -1 &&
          data.path.indexOf("/ristoranti-buongusto/Cermenate") == -1
        ) {
          data.path = "/page/buongusto";
        }
        if (data.path.indexOf("/t/le-14-follie-tigros") != -1) {
          data.path = "/page/le-14-follie-tigros";
        }
        let resolved = this.$router.resolve({
          path: data.path
        });
        if (
          resolved &&
          resolved.route.matched.length > 0 &&
          resolved.route.name != "DefaultRoute"
        ) {
          setTimeout(async function() {
            if (queryString) {
              var keyValPairs = queryString.split("&");
              for (var pairNum in keyValPairs) {
                var key = keyValPairs[pairNum].split("=")[0];
                if (key.length > 0) {
                  if (typeof currentQuery[key] === "undefined")
                    currentQuery[key] = "";
                  currentQuery[key] = keyValPairs[pairNum].split("=")[1];
                }
              }
              currentQuery.q = queryString
                .replace("q=", "")
                .replace(/%20/g, " ");
              console.log("onDeepLinks currentQuery :::: ", currentQuery);
              _this.$router.push({
                path: data.path,
                query: currentQuery
              });
            } else {
              _this.$router.push(data.path);
            }
          }, 100);
        } else {
          if (this.$platform_is_cordova && data.url.indexOf("http") > -1) {
            //if app open on _system browser
            window.cordova.InAppBrowser.open(data.url, "_system");
          }
        }
      } else {
        if (this.$platform_is_cordova && data.url.indexOf("http") > -1) {
          //if app open on _system browser
          window.cordova.InAppBrowser.open(data.url, "_system");
        }
      }
    },
    onAppTrackingTransparency() {
      var _this = this;
      // eslint-disable-next-line no-undef
      let platform = device ? device.platform.toLowerCase() : "ios";
      if (
        _this.$platform_is_cordova &&
        platform == "ios" &&
        window.plugins.impacTracking
      ) {
        console.log("Calling onAppTrackingTransparency");
        window.plugins.impacTracking.trackingAvailable(
          function(available) {
            if (!available) {
              console.log(
                "Tracciamento non disponibile o disabilitato dall'utente"
              );
              window.plugins.impacTracking.canRequestTracking(
                function(result) {
                  // Show results in the console
                  console.log(result);
                  if (result == true) {
                    // eslint-disable-next-line no-undef
                    Cookiebot.hide();
                    window.plugins.impacTracking.requestTracking(
                      undefined,
                      function(res) {
                        console.log(res);
                        _this.attValue = res;
                        if (res == true) {
                          // eslint-disable-next-line no-undef
                          Cookiebot.submitCustomConsent(true, true, true);
                        }
                        if (res == false) {
                          // eslint-disable-next-line no-undef
                          Cookiebot.hide();
                        }
                      },
                      function(err) {
                        console.log(err);
                        //TODO: tracking non abilitato
                      }
                    );
                  }
                },
                function(err) {
                  console.log(err);
                  //TODO: c'è stato un errore: tracking non abilitato
                }
              );
            } else {
              window.plugins.impacTracking.requestTracking(
                undefined,
                function(res) {
                  console.log(
                    "Calling onAppTrackingTransparency; already defined"
                  );
                  console.log("AppTracking enabled: " + res);
                  _this.attValue = res;
                  // eslint-disable-next-line no-undef
                  var stats = Cookiebot.consent.statistics;
                  // eslint-disable-next-line no-undef
                  var mrkg = Cookiebot.consent.marketing;
                  // eslint-disable-next-line no-undef
                  var pref = Cookiebot.consent.preferences;
                  // eslint-disable-next-line no-undef
                  Cookiebot.submitCustomConsent(pref, stats, mrkg);
                  if (res == false) {
                    // eslint-disable-next-line no-undef
                    Cookiebot.hide();
                  }
                },
                function(err) {
                  console.log(err);
                }
              );
            }
          },
          function(err) {
            console.log(err);
          }
        );
      }
    },
    async refreshLogin() {
      if (global.config.pushNotificationEnabled) {
        console.log("REFRESH LOGIN - REGISTER FIREBASE DEVICE");
        // Al Deviceready facciamo un refresh login per controllare se l'utente è ancora collegato
        // await SecurityService.refreshLogin();
        // await this.registerFirebaseDevice();
      }
    },
    ...mapActions({
      loadCart: "cart/loadCart"
    }),
    isPlatformIos() {
      if (this.isCordova && window.cordova.platformId.toLowerCase() === "ios") {
        this.platformIos = true;
      }
    },
    async checkMissingDisclaimer() {
      let response = await UserService.checkUserDisclaimer(2);
      if (
        response &&
        response.registrationModules &&
        response.registrationModules.length > 0
      ) {
        await this.openDialog(CheckDisclaimerDialog, {
          waitForResult: true,
          fullscreen: false
        });
      }
    }
  },
  async created() {
    await setLocale("en");
    this.i18nLoaded = true;
    var _this = this;
    this.fetchFooterLinksMenu();
    this.fetchApplicationConfig();
    try {
      if (_this.$cookies.get("X-Ebsn-Session")) {
        await _this.loadCart();
      } else if (window.localStorage.getItem("X-Ebsn-Session")) {
        let session = window.localStorage.getItem("X-Ebsn-Session");
        _this.$cookies.set("X-Ebsn-Session", session);

        let account = window.localStorage.getItem("X-Ebsn-Account");
        _this.$cookies.set("X-Ebsn-Account", account);

        await _this.loadCart();
      } else {
        analyticsService.initCustomDimension();
      }
    } finally {
      _this.loading = false;
    }
    //generate fingerprint
    // const fp = await FingerprintJS.load({ monitoring: false });
    // this.updateFingerprint(await fp.get());

    global.EventBus.$on("isNotLoggedIn", () => {
      _this.updateAuth();
      _this.handleLogin();
    });
    global.EventBus.$on("restart", () => {
      _this.updateLastStartTime();
      window.location.reload();
    });
    global.EventBus.$on("resetFilters", () => {
      _this.resetFilters(Math.random());
    });
    setTimeout(function() {
      _this.key = _this.key + 1;
    }, 3000);
    //eventi legati a cordova, partono solo al deviceready che viene scatenato da cordova quanto la app è pronta
    document.addEventListener(
      "deviceready",
      () => {
        setTimeout(function() {
          if (window.innerWidth < 600) {
            screen.orientation.lock("portrait");
          }
        }, 1500);

        //save last start time
        _this.updateLastStartTime();

        document.addEventListener("resume", _this.onResume, false);

        //TODO: cambiare gestione da config.js alla router clicked
        window.IonicDeeplink.route(
          global.config.deeplinks,
          function(match) {
            _this.resolveRoute(match.$link);
          },
          function(nomatch) {
            console.log("NOMATCH :::: ", nomatch);
            _this.resolveRoute(nomatch.$link);
          }
        );

        //con x secondi controllo se c'è una versione più recente
        this.checkVersion();

        this.isPlatformIos();

        if (this.isCordova) {
          window.open = window.cordova.InAppBrowser.open;
        }

        this.onAppTrackingTransparency();

        // Plugin Keyboard
        window.addEventListener("keyboardDidHide", () => {
          // Describe your logic which will be run each time keyboard is closed.
          console.log("keyboardDidHide");
          _this.keyboardOpen = false;
        });
        window.addEventListener("keyboardDidShow", event => {
          // Describe your logic which will be run each time when keyboard is about to be shown.
          console.log(event.keyboardHeight);
          console.log("keyboardDidShow");
          _this.keyboardOpen = true;
        });
        window.addEventListener("keyboardWillShow", event => {
          // Describe your logic which will be run each time when keyboard is about to be shown.
          console.log(event.keyboardHeight);
          console.log("keyboardWillShow");
          //iOS fix
          _this.keyboardOpen = true;
        });
        window.addEventListener("keyboardWillHide", () => {
          // Describe your logic which will be run each time when keyboard is about to be closed.
          console.log("keyboardWillHide");
          //iOS fix

          _this.keyboardOpen = false;
        });
        window.addEventListener(
          "CookiebotOnAccept",
          function() {
            _this.attValue = true;
          },
          false
        );
        window.addEventListener(
          "CookiebotOnDecline",
          function() {
            console.log("CookiebotOnDecline");
            _this.attValue = false;
          },
          false
        );
        window.addEventListener(
          "CookiebotOnDialogDisplay",
          function() {
            console.log("Calling CookiebotOnDialogDisplay");
            // eslint-disable-next-line no-undef
            var hasResponded = Cookiebot.consented || Cookiebot.declined;
            if (
              window.cordova &&
              window.cordova.platformId.toLowerCase() == "ios" &&
              window.plugins.impacTracking &&
              !_this.attResponse
            ) {
              if (_this.attValue) {
                console.log("Ho cliccato su consenti");
                // Ho cliccato su "Consenti"
                // eslint-disable-next-line no-undef
                var stats = Cookiebot.consent.statistics;
                // eslint-disable-next-line no-undef
                var mrkg = Cookiebot.consent.marketing;
                // eslint-disable-next-line no-undef
                var pref = Cookiebot.consent.preferences;
                if (!hasResponded) {
                  console.log("Not responded");
                  // eslint-disable-next-line no-undef
                  Cookiebot.submitCustomConsent(true, true, true);
                  _this.attResponse = true;
                  // eslint-disable-next-line no-undef
                  Cookiebot.hide();
                } else {
                  console.log("Has responded");
                  // eslint-disable-next-line no-undef
                  Cookiebot.submitCustomConsent(pref, stats, mrkg);
                  _this.attResponse = true;
                }
              } else {
                console.log("Ho cliccato su non consentire");
                //Ho cliccato su "non consentire"
                // eslint-disable-next-line no-undef
                var declined = Cookiebot.declined;
                // eslint-disable-next-line no-undef
                Cookiebot.withdraw();
                _this.attResponse = true;
                if (!declined) {
                  console.log("First time");
                  //first time
                  // eslint-disable-next-line no-undef
                  Cookiebot.hide();
                }
              }
            }
          },
          false
        );

        this.refreshLogin();
      },
      false
    );
    if (this.isCordova) {
      //add platfrm to body element
      let platform = window.cordova.platformId;
      document.body.classList.add(platform);
    } else {
      //add platfrm to body element
      let platform = navigator.userAgentData
        ? navigator.userAgentData.platform
        : navigator.platform;
      document.body.classList.add(platform);
      this.checkOsx();
    }
  },
  mounted() {
    // Avoid loading Cookiebot if the page is server rendered (Prerender.io)
    // DOC: Prerender.io crawler User-Agent will always contain: "Prerender (+https://github.com/prerender/prerender)" - src:   https://docs.prerender.io/docs/33-overview-of-prerender-crawlers
    if (!navigator.userAgent.match("Prerender|GTmetrix|Googlebot")) {
      // let cookiebotScript = document.createElement("script");
      // cookiebotScript.setAttribute("id", "Cookiebot");
      // cookiebotScript.setAttribute(
      //   "src",
      //   "https://consent.cookiebot.com/uc.js"
      // );
      // cookiebotScript.setAttribute(
      //   "data-cbid",
      //   "41083223-3ed8-41f5-87c1-eebd5ccd75b8"
      // );
      // cookiebotScript.setAttribute("type", "text/javascript");
      // cookiebotScript.async = true;
      // document.head.appendChild(cookiebotScript);
    }
  },
  beforeDestroy() {
    global.EventBus.$off("isNotLoggedIn");
    global.EventBus.$off("restart");
    global.EventBus.$off("resetFilters");
  }
};
</script>
